import React, { useEffect, useState } from "react";
import "../css/dashboard.css";
import "../css/client.css";
import { Box, Modal } from "@mui/material";
import TopTitleBannerMobile from "../component/TopTitleBannerMobile";
import AddClientMobile from "../component/forms/AddClientMobile";
import { useAuth } from "../contexts/AuthContext";
import { documentId, onSnapshot, query, where } from "firebase/firestore";
import { roles } from "../firebase.collection";

export default function NoMobileView(props) {
  const { currentUser } = useAuth();
  const userIdState = currentUser ? currentUser.uid : "";
  const [, setUserRole] = useState("");
  const styleModalGeneral = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    height: 600,
    backgroundColor: "white",
    boxShadow: 24,
  };

  const [openAddClient, setOpenAddClient] = useState(false);

  const handleCloseAddClient = () => setOpenAddClient(false);

  function queryRole() {
    onSnapshot(
      query(roles, where(documentId(), "==", userIdState)),
      (querySnapshot) => {
        const doc = querySnapshot.docs[0];
        if (doc && doc.exists) {
          const role = doc.data().role;
          setUserRole(role);
        } else {
          console.log("No role for this user");
        }
      }
    );
  }

  useEffect(() => {
    if (currentUser) {
      queryRole();
    } else {
      console.log("No user id");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  return (
    <div className="right-container-mobile">
      <Modal
        open={openAddClient}
        onClose={handleCloseAddClient}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral}>
          <AddClientMobile closemodal={handleCloseAddClient} />
        </Box>
      </Modal>
      <TopTitleBannerMobile title={props.title} />
      <div className="top-component-list-clients-mobile"></div>
      <div style={{ paddingLeft: "60px", fontWeight: "500" }}>
        PLEASE SWITCH TO DESKTOP VIEW
      </div>
    </div>
  );
}
